var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalitec(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144.18 65.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eab28f;}.cls-2{fill:#020453;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.65,1.38V32.14A1.38,1.38,0,0,0,53,33.52h9.29a1.38,1.38,0,0,0,1.38-1.38V1.38A1.38,1.38,0,0,0,62.32,0H53A1.38,1.38,0,0,0,51.65,1.38ZM61.4,31.21H54V2.3H61.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.21,7.39V32.14a1.38,1.38,0,0,0,1.38,1.38h9.14a1.37,1.37,0,0,0,1.37-1.38V7.39A1.37,1.37,0,0,0,76.73,6H67.59A1.38,1.38,0,0,0,66.21,7.39ZM75.8,31.21H68.51V8.31H75.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.67,13V32.14A1.37,1.37,0,0,0,82,33.52h8.83a1.38,1.38,0,0,0,1.38-1.38V13a1.38,1.38,0,0,0-1.38-1.38H82A1.37,1.37,0,0,0,80.67,13Zm9.27,18.25H83V13.88h7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.15,51.69v1.48c0,3-1.73,4.65-4.9,4.65H3v7.62H0V47H4.25C7.42,47,9.15,48.67,9.15,51.69ZM3,49.62v5.62H4.14c1.42,0,2.06-.71,2.06-2.26v-1.1c0-1.55-.64-2.26-2.06-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.63,49.62H15.47v5.2h4.16V57.4H15.47v5.47h5.16v2.57h-8V47h8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.92,65.44l-2.35-7.78H27.2v7.78h-3V47h4.28c3.2,0,4.93,1.63,4.93,4.65V53a4.22,4.22,0,0,1-2.1,4.05l2.72,8.38ZM27.2,49.62v5.47h1.2c1.43,0,2.07-.71,2.07-2.27v-.94c0-1.55-.64-2.26-2.07-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.77,50.9v.48l-2.93.26V51a1.56,1.56,0,1,0-3.11,0v.23c0,1.08.52,2,2.56,3.58,2.79,2.16,3.82,3.68,3.82,5.89v.92c0,2.63-1.69,4.13-4.71,4.13s-4.72-1.5-4.72-4.13V60.34l2.93-.26v1.31a1.73,1.73,0,1,0,3.46,0v-.6c0-1.16-.61-2.08-2.65-3.65-2.79-2.16-3.74-3.69-3.74-5.84v-.4c0-2.62,1.64-4.12,4.55-4.12S46.77,48.28,46.77,50.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.2,51.43v9.62c0,2.9-1.86,4.66-4.89,4.66S51.42,64,51.42,61.05V51.43c0-2.89,1.86-4.65,4.89-4.65S61.2,48.54,61.2,51.43Zm-6.75,0V61c0,1.36.66,2.1,1.86,2.1s1.86-.74,1.86-2.1V51.46c0-1.37-.66-2.11-1.86-2.11S54.45,50.09,54.45,51.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.26,65.44H72.45l-3.76-12.2h-.06v12.2h-2.7V47h3.19L72.5,58h.06V47h2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.53,65.44h-3l-.65-4.18H82.55l-.65,4.18h-3L82.32,47h3.8ZM84.15,51l-1.21,7.76h2.51L84.24,51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96,62.81h4.65v2.63H93.25V47H96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.94,65.44h-2.78V47h2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.77,49.67h-3.1V65.44h-2.91V49.67h-3.11V47h9.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.36,49.62h-5.05v5.2h4.08V57.4h-4.08v5.47h5.05v2.57h-7.83V47h7.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.18,51.19v1.66l-3.05.13v-1.5c0-1.47-.63-2.13-1.8-2.13a1.65,1.65,0,0,0-1.8,1.87v10a1.65,1.65,0,0,0,1.8,1.87c1.17,0,1.8-.66,1.8-2.13V59l3.05.13v2.21c0,2.79-1.83,4.42-4.94,4.42s-4.89-1.63-4.89-4.42V51.19c0-2.78,1.8-4.41,4.89-4.41S144.18,48.41,144.18,51.19Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalitec);
export default __webpack_public_path__ + "static/media/personalitec.6677b7b64c02b10a7dc7cc35f286ae02.svg";
export { ForwardRef as ReactComponent };